// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import styled from 'styled-components'

import type { Term } from 'lib-common/application/validations'
import { Label } from 'lib-components/typography'
import { Gap } from 'lib-components/white-space'

import type { ApplicationEditorDeps } from '../types'

const Ul = styled.ul`
  margin: 0;
`

interface Props {
  deps: ApplicationEditorDeps
  clubTerms: Term[]
}

export function ClubTermsInfo({ deps, clubTerms }: Props) {
  const { translations: i18n } = deps

  return (
    <>
      <Label>
        {
          i18n.applications.editor.serviceNeed.startDate[
            clubTerms.length === 1 ? 'clubTerm' : 'clubTerms'
          ]
        }
      </Label>
      <Gap $size="s" />
      <Ul data-qa="club-terms">
        {clubTerms.map((term, i) => (
          <li key={i}>{term.extendedTerm.format()}</li>
        ))}
      </Ul>
      <Gap $size="m" />
    </>
  )
}
